import Vuex from 'vuex'
import general from './modules/general.js'

const createStore = () => {
    return new Vuex.Store({
        modules: {
            general
        }
    })
}

export default createStore
